import { render, staticRenderFns } from "./UploadsList.vue?vue&type=template&id=1054d742&scoped=true"
import script from "./UploadsList.vue?vue&type=script&lang=js"
export * from "./UploadsList.vue?vue&type=script&lang=js"
import style0 from "./UploadsList.vue?vue&type=style&index=0&id=1054d742&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1054d742",
  null
  
)

export default component.exports